/**
 * Shared timing constants — hoisted from magic numbers across the app so the
 * *intent* (not the literal) is readable and tunable in one place.
 * See CLEANUP.md / CLEANUP_JOBS.md CATEGORY 3.6 (Magic numbers / timeouts).
 */

// ─── Domain & email constants (centralised — CATEGORY 1.5) ───
// Import SITE_URL from seoRouting for full URLs; these are for email references only.

export const SUPPORT_EMAIL = 'support@mondivago.com';
export const PRIVACY_EMAIL = 'privacy@mondivago.com';
export const SECURITY_EMAIL = 'security@mondivago.com';
export const INFO_EMAIL = 'info@mondivago.com';

// ─── Intervals

/** Carousel auto-advance interval (ActivityCard image carousel). */
export const CAROUSEL_INTERVAL_MS = 2000;
/** Default toast auto-dismiss time-to-live. */
export const TOAST_TTL_MS = 5000;
/** Delay before clearing a transient "copied" / success flag. */
export const TOAST_CLEAR_MS = 2000;
/** Delay before resetting a form/modal after a success transition. */
export const RESET_DELAY_MS = 2000;
/** Delay before resetting the AI assistant modal after close. */
export const AI_ASSISTANT_RESET_DELAY_MS = 300;
/** Delay before focusing the currency search input when the tab opens. */
export const FOCUS_DELAY_MS = 50;
/** Delay before auto-closing a hover dropdown on mouse-leave. */
export const AUTO_CLOSE_MS = 150;
/** Delay before Stripe is considered ready (fallback). */
export const STRIPE_READY_MS = 800;
/** Delay before re-running a wallet refresh after a top-up success. */
export const WALLET_REFRESH_MS = 2000;
/** Secondary wallet refresh delay (longer settle window). */
export const WALLET_REFRESH_LONG_MS = 5000;
/** Delay before scrolling to a newly-added tour addon. */
export const ADDON_SCROLL_MS = 100;
/** Delay before clearing the section-scroll lock in TourForm. */
export const SECTION_SCROLL_LOCK_MS = 800;
/** Zero-delay microtask used to defer a synchronous state update in an effect. */
export const MICROTASK_MS = 0;
